import React from "react";
import { useContext } from "../../context";
import styles from "./styles.module.scss";

export function LinkToMainProviderDetails() {
  const { appointment } = useContext();

  if (!appointment.isAdditionalProviderAppointment) {
    return null;
  }

  return (
    <a
      href={`/appointment/view/${appointment.mainAppointmentId}?view_details=true&provider_id=${appointment.additionalProviderId}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.root}
    >
      Open Main Provider Details
    </a>
  );
}
